import React, { useState, useEffect,useMemo} from 'react';
import {
  Box,
  Container,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Divider,
  Breadcrumbs,
  Card,
  CardContent,
  styled,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import {
  Edit as EditIcon,
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  PhotoCamera as PhotoCameraIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  Phone as PhoneIcon,
  Public as PublicIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import S3FileUpload from 'react-s3';
import AWS from 'aws-sdk';
import { CostomerupdateProfile } from "./action/auth";
import { useAuthToken } from "../TokenContext";
import defaultimg from './assets/defaultimge.png';
import { useCredentials } from '../useCredentials';
import { useTheme } from '@mui/material';
// AWS Configuration


 const countries = [ { value: 'usa', label: 'USA' },
  { value: 'canada', label: 'Canada' },
  { value: 'india', label: 'India' },
  { value: 'australia', label: 'Australia' },
  { value: 'united_kingdom', label: 'United Kingdom' },
  { value: 'germany', label: 'Germany' },
  { value: 'france', label: 'France' },
  { value: 'china', label: 'China' },
  { value: 'japan', label: 'Japan' },
  { value: 'brazil', label: 'Brazil' },
  { value: 'south_africa', label: 'South Africa' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'italy', label: 'Italy' },
  { value: 'spain', label: 'Spain' },
  { value: 'russia', label: 'Russia' },
  { value: 'south_korea', label: 'South Korea' },
  { value: 'new_zealand', label: 'New Zealand' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'united_arab_emirates', label: 'United Arab Emirates' },
  { value: 'saudi_arabia', label: 'Saudi Arabia' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'netherlands', label: 'Netherlands' },
  { value: 'sweden', label: 'Sweden' },
  { value: 'switzerland', label: 'Switzerland' },
  { value: 'norway', label: 'Norway' },
  { value: 'denmark', label: 'Denmark' },
  { value: 'finland', label: 'Finland' },
  { value: 'portugal', label: 'Portugal' },
  { value: 'poland', label: 'Poland' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'malaysia', label: 'Malaysia' },
  { value: 'thailand', label: 'Thailand' },
  { value: 'vietnam', label: 'Vietnam' },
  { value: 'philippines', label: 'Philippines' },
  { value: 'egypt', label: 'Egypt' },
  { value: 'nigeria', label: 'Nigeria' },
  { value: 'kenya', label: 'Kenya' },
  { value: 'ghana', label: 'Ghana' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'chile', label: 'Chile' },
  { value: 'peru', label: 'Peru' },
  { value: 'venezuela', label: 'Venezuela' },
  { value: 'pakistan', label: 'Pakistan' },
  { value: 'bangladesh', label: 'Bangladesh' },
  { value: 'sri_lanka', label: 'Sri Lanka' },
  { value: 'nepal', label: 'Nepal' },
  { value: 'bhutan', label: 'Bhutan' },
  { value: 'maldives', label: 'Maldives' },
  { value: 'iceland', label: 'Iceland' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'qatar', label: 'Qatar' },
  { value: 'oman', label: 'Oman' },
  { value: 'kuwait', label: 'Kuwait' },
  { value: 'bahrain', label: 'Bahrain' },
  { value: 'iraq', label: 'Iraq' },
  { value: 'iran', label: 'Iran' },
  { value: 'afghanistan', label: 'Afghanistan' },
  { value: 'israel', label: 'Israel' },
  { value: 'jordan', label: 'Jordan' },
  { value: 'lebanon', label: 'Lebanon' },
  { value: 'morocco', label: 'Morocco' },
  { value: 'algeria', label: 'Algeria' },
  { value: 'tunisia', label: 'Tunisia' },
  { value: 'libya', label: 'Libya' },
  { value: 'ethiopia', label: 'Ethiopia' },
  { value: 'tanzania', label: 'Tanzania' },
  { value: 'uganda', label: 'Uganda' },
  { value: 'zimbabwe', label: 'Zimbabwe' },
  { value: 'zambia', label: 'Zambia' },
  { value: 'mozambique', label: 'Mozambique' },
  { value: 'botswana', label: 'Botswana' },
  { value: 'namibia', label: 'Namibia' },
  { value: 'angola', label: 'Angola' },
  { value: 'cuba', label: 'Cuba' },
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'haiti', label: 'Haiti' },
  { value: 'dominican_republic', label: 'Dominican Republic' },
  { value: 'trinidad_and_tobago', label: 'Trinidad and Tobago' },
  { value: 'bahamas', label: 'Bahamas' },
  { value: 'barbados', label: 'Barbados' },
  { value: 'panama', label: 'Panama' },
  { value: 'costa_rica', label: 'Costa Rica' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'guatemala', label: 'Guatemala' },
  { value: 'el_salvador', label: 'El Salvador' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'belize', label: 'Belize' },
  { value: 'paraguay', label: 'Paraguay' },
  { value: 'uruguay', label: 'Uruguay' },
  { value: 'bolivia', label: 'Bolivia' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'guinea', label: 'Guinea' },
  { value: 'ivory_coast', label: 'Ivory Coast' },
  { value: 'cameroon', label: 'Cameroon' },
  { value: 'senegal', label: 'Senegal' },
  { value: 'sudan', label: 'Sudan' },
  { value: 'south_sudan', label: 'South Sudan' },
  { value: 'congo', label: 'Congo' },
  { value: 'madagascar', label: 'Madagascar' },
  { value: 'malawi', label: 'Malawi' },
  { value: 'sierra_leone', label: 'Sierra Leone' },
  { value: 'chad', label: 'Chad' },
  { value: 'mali', label: 'Mali' },
  { value: 'burkina_faso', label: 'Burkina Faso' },
  { value: 'rwanda', label: 'Rwanda' },
  { value: 'burundi', label: 'Burundi' },
  { value: 'lesotho', label: 'Lesotho' },
  { value: 'eswatini', label: 'Eswatini' }

  ];
const countryCodes = ['+1', '+44', '+91', '+81', '+86'];

// Styled Components
const ProfileContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(10),
  marginBottom: theme.spacing(8)
}));

const ProfileCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 4px 24px 0 rgba(34, 41, 47, 0.1)',
  overflow: 'visible',
  position: 'relative'
}));

const ProfileHeader = styled(Box)(({ theme }) => ({
  height: 200,
  background: 'linear-gradient(135deg, #03045e 0%, #0077b6 100%)',
  borderRadius: '16px 16px 0 0',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  padding: '16px',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '40%',
    background: 'linear-gradient(to top, rgba(0,0,0,0.4), transparent)'
  }
}));

const ProfileAvatarWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: -60,
  transform: 'translateX(-50%)',
  zIndex: 2
}));

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  border: `4px solid ${theme.palette.background.paper}`,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
}));



// Add this inside the component

// Update the InfoSection styled component
const InfoSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50],
  borderRadius: 12,
  marginBottom: theme.spacing(3)
}));

// Update the StyledTextField component
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.background.paper,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#f8fafc'
    },
    '&.Mui-focused': {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
      boxShadow: '0 0 0 2px rgba(0, 180, 216, 0.2)'
    }
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.mode === 'dark' ? theme.palette.grey[300] : 'inherit'
  },
  '& .MuiOutlinedInput-input': {
    color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : 'inherit'
  }
}));

const PhoneInputWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(3)
}));



const CustomerProfile = () => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();
const theme = useTheme();
const isDarkMode = theme.palette.mode === 'dark';


    const config = useMemo(() => ({
      bucketName: credentials.bucketName,
      region: credentials.region,
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey
    }), [credentials]);
  
      
        const S3Config = useMemo(() => ({
          bucketName: credentials.bucketName,
          region: credentials.region,
          accessKeyId: credentials.accessKeyId,
          secretAccessKey: credentials.secretAccessKey
        }), [credentials]);
  const token = useAuthToken();
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector(state => state.auth);

  const [state, setState] = useState({
    fname: user.data[0].customer_firstname || '',
    mname: user.data[0].customer_middlename || '',
    lname: user.data[0].customer_lastname || '',
    country: user.data[0].customer_country || '',
    about: user.data[0].about || '',
    email: user.data[0].email || '',
    phone_number: user.data[0].phone_number || '',
    profilePicture: user.data[0].profilePicture || ''
  });

  const [phoneState, setPhoneState] = useState({
    countryCode: state.phone_number ? state.phone_number.slice(0, 3) : '+1',
    number: state.phone_number ? state.phone_number.slice(3) : ''
  });

  const [edit, setEdit] = useState(user.data[0].profile === 0);
  const [image, setImage] = useState('');
  const [uploading, setUploading] = useState(false);
  const [authImage, setAuthImage] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    generatePreSignedUrl();
  }, []);

  const generatePreSignedUrl = async () => {
    if (!state.profilePicture) return;

    try {
      const response = await fetch(process.env.REACT_APP_TALENT_CLOUDFRONTAPI, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: process.env.REACT_APP_CLOUDFRONT + state.profilePicture
        })
      });
      
      const data = await response.json();
      if (data.body) {
        const signedUrl = JSON.parse(data.body).signedUrl;
        setAuthImage(signedUrl);
      }
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setSnackbar({
        open: true,
        message: 'Failed to load profile picture',
        severity: 'error'
      });
    }
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setSnackbar({
        open: true,
        message: "File size should be less than 5MB",
        severity: "error"
      });
      return;
    }

    setUploading(true);
    try {
      const preview = URL.createObjectURL(file);
      setImage(preview);

      const uploadResult = await S3FileUpload.uploadFile(file, config);
      setState(prev => ({
        ...prev,
        profilePicture: uploadResult.key
      }));

      setSnackbar({
        open: true,
        message: "Profile picture updated successfully",
        severity: "success"
      });
    } catch (error) {
      console.error("Upload error:", error);
      setSnackbar({
        open: true,
        message: "Failed to upload profile picture",
        severity: "error"
      });
      setImage("");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      const data = {
        customer_id: user.data[0].customer_id,
        customer_firstname: state.fname,
        phone_number: `${phoneState.countryCode}${phoneState.number}`,
        customer_middlename: state.mname,
        customer_lastname: state.lname,
        customer_country: state.country,
        about: state.about,
        profilePicture: state.profilePicture
      };

      await dispatch(CostomerupdateProfile(data, {
        'Authorization': token,
        'Content-Type': 'application/json'
      }));

      setSnackbar({
        open: true,
        message: "Profile updated successfully",
        severity: "success"
      });

      setTimeout(() => {
        window.location.href = "/subscriptions";
      }, 1500);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to update profile",
        severity: "error"
      });
    }
  };

  const handleInputChange = (e) => {
    setState(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  return (
    <ProfileContainer maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link 
            to="/subscriptions"
            style={{
              color: '#03045e',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: 600
            }}
          >
            Subscription
          </Link>
          <Typography color="textSecondary" fontWeight={600}>
            Manage Profile
          </Typography>
        </Breadcrumbs>
      </Box>

      <ProfileCard>
        <ProfileHeader>
          <ProfileAvatarWrapper>
            <ProfileAvatar
              src={image || authImage || defaultimg}
              alt={state.fname}
            />
            {edit && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  opacity: 0,
                  transition: '0.3s',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  '&:hover': { opacity: 1 }
                }}
              >
                <label htmlFor="profile-image">
                  <input
                    accept="image/*"
                    type="file"
                    hidden
                    id="profile-image"
                    onChange={handleImageUpload}
                  />
                  <IconButton 
                    component="span"
                    sx={{ 
                      color: 'white',
                      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                    }}
                  >
                    <PhotoCameraIcon />
                  </IconButton>
                </label>
              </Box>
            )}
          </ProfileAvatarWrapper>

          {!edit && (
            <IconButton
           sx={{
      position: 'absolute',
      right: 16,
      top: 180,
      backgroundColor: isDarkMode ? 'grey.800' : 'white',
      color: isDarkMode ? 'grey.100' : 'inherit',
      boxShadow: isDarkMode 
        ? '0 2px 8px rgba(0,0,0,0.3)' 
        : '0 2px 8px rgba(0,0,0,0.1)',
      border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : 'none',
      '&:hover': { 
        backgroundColor: isDarkMode ? 'grey.700' : '#f0f0f0' 
      }
    }}
              onClick={() => setEdit(true)}
            >
              <EditIcon />
            </IconButton>
          )}
        </ProfileHeader>

        <CardContent sx={{ pt: 10 }}>
          {edit ? (
  <form onSubmit={handleSubmit}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="First Name"
          id="fname"
          value={state.fname}
          onChange={handleInputChange}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="Middle Name"
          id="mname"
          value={state.mname}
          onChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="Last Name"
          id="lname"
          value={state.lname}
          onChange={handleInputChange}
          required
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <PhoneInputWrapper>
          <FormControl 
            sx={{ 
              width: '30%',
              '& .MuiOutlinedInput-root': {
                backgroundColor: isDarkMode ? 'grey.800' : 'background.paper'
              },
              '& .MuiInputLabel-root': {
                color: isDarkMode ? 'grey.300' : 'inherit'
              }
            }}
          >
            <InputLabel>Code</InputLabel>
            <Select
              value={phoneState.countryCode}
              onChange={(e) => setPhoneState(prev => ({
                ...prev,
                countryCode: e.target.value
              }))}
              label="Code"
              sx={{
                color: isDarkMode ? 'grey.100' : 'inherit'
              }}
            >
              {countryCodes.map(code => (
                <MenuItem 
                  key={code} 
                  value={code}
                  sx={{
                    color: isDarkMode ? 'grey.100' : 'inherit',
                    backgroundColor: isDarkMode ? 'grey.800' : 'inherit',
                    '&:hover': {
                      backgroundColor: isDarkMode ? 'grey.700' : 'action.hover'
                    }
                  }}
                >
                  {code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <StyledTextField
            sx={{ width: '70%' }}
            label="Phone Number"
            value={phoneState.number}
            onChange={(e) => setPhoneState(prev => ({
              ...prev,
              number: e.target.value
            }))}
            required
          />
        </PhoneInputWrapper>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl 
          fullWidth 
          sx={{ 
            mb: 3,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: isDarkMode ? 'grey.800' : 'background.paper'
            },
            '& .MuiInputLabel-root': {
              color: isDarkMode ? 'grey.300' : 'inherit'
            }
          }}
        >
          <InputLabel>Country</InputLabel>
          <Select
            value={state.country}
            onChange={(e) => setState(prev => ({
              ...prev,
              country: e.target.value
            }))}
            label="Country"
            required
            sx={{
              color: isDarkMode ? 'grey.100' : 'inherit'
            }}
          >
            {countries.map(country => (
              <MenuItem 
                key={country.value} 
                value={country.value}
                sx={{
                  color: isDarkMode ? 'grey.100' : 'inherit',
                  backgroundColor: isDarkMode ? 'grey.800' : 'inherit',
                  '&:hover': {
                    backgroundColor: isDarkMode ? 'grey.700' : 'action.hover'
                  }
                }}
              >
                {country.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <StyledTextField
          fullWidth
          multiline
          rows={4}
          label="About"
          id="about"
          value={state.about}
          onChange={handleInputChange}
          required
        />
      </Grid>

      <Grid item xs={12}>
        <StyledTextField
          fullWidth
          label="Email"
          value={state.email}
          disabled
          type="email"
        />
      </Grid>
    </Grid>

    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
      <Button
        variant="outlined"
        onClick={() => setEdit(false)}
        startIcon={<CloseIcon />}
        sx={{
          borderColor: isDarkMode ? 'grey.600' : 'inherit',
          color: isDarkMode ? 'grey.300' : 'inherit',
          '&:hover': {
            borderColor: isDarkMode ? 'grey.500' : 'inherit',
            backgroundColor: isDarkMode ? 'grey.800' : 'inherit'
          }
        }}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        startIcon={<SaveIcon />}
        disabled={uploading}
        sx={{
          backgroundColor: isDarkMode ? '#0577b6' : '#03045e',
          '&:hover': { 
            backgroundColor: isDarkMode ? '#0466a3' : '#0077b6' 
          }
        }}
      >
        {uploading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          user.data[0].profile === 0 ? 'Create Profile' : 'Save Changes'
        )}
      </Button>
    </Box>
  </form>
) : (
  <Box>
    <Typography 
      variant="h5" 
      align="center" 
      gutterBottom
      sx={{ color: isDarkMode ? 'grey.100' : 'text.primary' }}
    >
      {`${state.fname} ${state.lname}`}
    </Typography>
    <Typography 
      variant="body1" 
      align="center" 
      sx={{ 
        mb: 4,
        color: isDarkMode ? 'grey.400' : 'text.secondary'
      }}
    >
      {state.email}
    </Typography>
    
    <InfoSection>
      <Typography 
        variant="h6" 
        color="primary" 
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Basic Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PhoneIcon sx={{ color: isDarkMode ? 'grey.400' : 'action.active' }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: isDarkMode ? 'grey.400' : 'text.secondary' }}
              >
                Phone Number
              </Typography>
              <Typography 
                variant="body1"
                sx={{ color: isDarkMode ? 'grey.100' : 'text.primary' }}
              >
                {state.phone_number}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PublicIcon sx={{ color: isDarkMode ? 'grey.400' : 'action.active' }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: isDarkMode ? 'grey.400' : 'text.secondary' }}
              >
                Country
              </Typography>
              <Typography 
                variant="body1"
                sx={{ color: isDarkMode ? 'grey.100' : 'text.primary' }}
              >
                {state.country}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <InfoIcon sx={{ 
              mt: 0.5, 
              color: isDarkMode ? 'grey.400' : 'action.active' 
            }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: isDarkMode ? 'grey.400' : 'text.secondary' }}
              >
                About
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  whiteSpace: 'pre-wrap',
                  color: isDarkMode ? 'grey.100' : 'text.primary'
                }}
              >
                {state.about}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </InfoSection>
  </Box>
)}
        </CardContent>
      </ProfileCard>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          elevation={6}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {uploading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(4px)'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress size={40} sx={{ color: '#03045e' }} />
            <Typography sx={{ mt: 2, color: '#03045e' }}>
              Uploading your profile picture...
            </Typography>
          </Box>
        </Box>
      )}
    </ProfileContainer>
  );
};

export default CustomerProfile;